<template>
    <receipt-layout>
        <template #meta>
            <div class="flex flex-col gap-2">
                <div class="flex justify-end">
                    <div class="text-[24px] font-semibold">INVOICE RECEIPT</div>
                </div>
                <div class="flex justify-end gap-4">
                    <div class="text-left font-semibold">ID:</div>

                    <div class="text-right">#{{ invoice.id }}</div>
                </div>
                <div class="flex justify-end gap-4">
                    <div class="text-left font-semibold">Issued:</div>
                    <div class="text-right">
                        {{
                            dayjs(invoice.created_at)
                                .utc(true)
                                .tz($page.props.auth.user.timezone)
                                .format("YYYY-MM-DD")
                        }}
                    </div>
                </div>
                <div class="flex justify-end gap-4">
                    <div class="text-left font-semibold">Paid At:</div>
                    <div class="text-right">
                        {{
                            dayjs(invoice.created_at)
                                .utc(true)
                                .tz($page.props.auth.user.timezone)
                                .format("YYYY-MM-DD")
                        }}
                    </div>
                </div>
                <div class="flex justify-end gap-4">
                    <div class="text-left font-semibold">Source:</div>
                    <div class="text-right capitalize">
                        {{ invoice.payment_type }} Payment
                    </div>
                </div>
                <div class="flex justify-end gap-4">
                    <div class="text-left font-semibold">For:</div>
                    <div class="text-right">
                        {{ invoice.user.full_name }}
                        <span class="ml-2 text-gray-700"
                            >[{{ invoice.user.email }}]</span
                        >
                    </div>
                </div>
            </div>
        </template>

        <div class="">
            <div class="mt-24">
                <table class="mb-24 table w-full">
                    <thead class="bg-primary-900 text-white">
                        <tr>
                            <th class="p-4 text-left">Item</th>
                            <th class="p-4 !text-right">Qty</th>
                            <th class="p-4 !text-right">Unit Price</th>
                            <th class="p-4 !text-right">Total</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr
                            v-if="typeof invoice.item_descriptions === 'string'"
                        >
                            <td colspan="2">{{ invoice.item_descriptions }}</td>
                        </tr>
                        <tr v-else v-for="item in invoice.invoice_items">
                            <td class="p-4 text-left">
                                <span
                                    v-html="item.product.display_title"
                                ></span>
                            </td>
                            <td class="p-4 text-right">{{ item.qty }}</td>
                            <td class="p-4 text-right">
                                <value-as-currency
                                    :value="item.item_price_usd"
                                ></value-as-currency>
                                /ea
                            </td>
                            <td class="p-4 text-right">
                                <value-as-currency
                                    :value="item.item_price_usd * item.qty"
                                ></value-as-currency>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="text-right">
                    <div class="">
                        Subtotal:

                        <value-as-currency
                            :value="invoice.subtotal_usd"
                        ></value-as-currency>
                    </div>

                    <div class="" v-if="invoice.discount_total">
                        <div class="">
                            Discount:
                            <value-as-currency
                                :value="invoice.discount_total"
                            ></value-as-currency>
                        </div>
                        <div class="text-[14px] text-gray-600">
                            {{ invoice.discount_from }}
                        </div>
                    </div>

                    <div class="mt-8 text-[24px] font-bold">
                        Total:
                        <value-as-currency
                            :value="invoice.total_usd"
                        ></value-as-currency>
                    </div>
                </div>
            </div>
        </div>
    </receipt-layout>
</template>

<script>
import ReceiptLayout from "@/_Layouts/ReceiptLayout";
import ValueAsCurrency from "@/Components/ValueAsCurrency";

export default {
    name: "Receipt",
    components: {
        ReceiptLayout,
        ValueAsCurrency,
    },
    props: {
        invoice: {
            type: Object,
            default: {},
        },
    },
};
</script>

<style scoped></style>
